import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var UpArrowIcon = function (_a) {
    var rotate = _a.rotate;
    return (_jsx("svg", { className: "w-4 h-4 transition-transform duration-200 transform", style: { transform: "rotate(".concat(rotate, "deg)") }, fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M19 9l-7 7-7-7' }) }));
};
